/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface DatabaseBackupResult
 */
export interface DatabaseBackupResult {
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseBackupResult
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DatabaseBackupResult
     */
    fileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseBackupResult
     */
    errorMessage?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseBackupResult
     */
    $type?: DatabaseBackupResultTypeEnum;
}


/**
 * @export
 */
export const DatabaseBackupResultTypeEnum = {
    PtwPtw100AppZeroApplicationSharedInstallDatabaseBackupResultPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Install.DatabaseBackupResult, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type DatabaseBackupResultTypeEnum = typeof DatabaseBackupResultTypeEnum[keyof typeof DatabaseBackupResultTypeEnum];



/**
 * Check if a given object implements the DatabaseBackupResult interface.
 */
export function instanceOfDatabaseBackupResult(value?: unknown): value is DatabaseBackupResult {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(DatabaseBackupResultTypeEnum)[0];
}

export function DatabaseBackupResultFromJSON(json: any): DatabaseBackupResult {
    return DatabaseBackupResultFromJSONTyped(json, false);
}

export function DatabaseBackupResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseBackupResult {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function DatabaseBackupResultToJSON(value?: DatabaseBackupResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'success': value['success'],
        'fileName': value['fileName'],
        'errorMessage': value['errorMessage'],
        '$type': value['$type'],
    });
}

